import { useEffect, useMemo, useState } from "react";
import {
  getPendingRoundExpiresAt,
  getPendingRoundSecondsLeft,
} from "../utils/bondDrawPendingExpiry";

export function useBondDrawPendingExpiry(round) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!round?._id) return undefined;
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [round?._id]);

  const expiresAt = useMemo(() => getPendingRoundExpiresAt(round), [round]);
  const deadline = expiresAt != null ? new Date(expiresAt).toISOString() : null;
  const secondsLeft = round ? getPendingRoundSecondsLeft(round, now) : null;
  const isExpired = secondsLeft === 0;

  return { deadline, secondsLeft, isExpired };
}
